import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from "rxjs/operators";

import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    constructor(private auth: AuthService) { }

    // TODO: handle 401 response?
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (!request.headers.has("X-No-Auth")) {
            return this.auth.getSessionIdJWT().pipe(
                switchMap(token => {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`
                        }
                    });

                    return next.handle(request);
                })
            );
        }

        request = request.clone({
            headers: request.headers.delete("X-No-Auth")
        });
        return next.handle(request);
    }
}
